export default "__VITE_ASSET__Cb1Z1tUL__"